/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Tab_GeneralInputs */

const en_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const fr_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Général`)
};

const de_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

const it_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generale`)
};

const ru_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий`)
};

const es_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const zh_cn2_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的`)
};

const ja_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な`)
};

const hi_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य`)
};

const pt_pt2_event_group_options_tab_general = /** @type {(inputs: Event_Group_Options_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em geral`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Event_Group_Options_Tab_GeneralInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_tab_general = /** @type {((inputs?: Event_Group_Options_Tab_GeneralInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Tab_GeneralInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_tab_general(inputs)
	if (locale === "de") return de_event_group_options_tab_general(inputs)
	if (locale === "it") return it_event_group_options_tab_general(inputs)
	if (locale === "ru") return ru_event_group_options_tab_general(inputs)
	if (locale === "es") return es_event_group_options_tab_general(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_tab_general(inputs)
	if (locale === "ja") return ja_event_group_options_tab_general(inputs)
	if (locale === "hi") return hi_event_group_options_tab_general(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_tab_general(inputs)
	return en_event_group_options_tab_general(inputs)
});